import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Form, Input } from "antd";
import { useI18n } from "../../../../../contexts";
import { FormValueDifferFromTemplateTag } from "../../..";
const FormContentBlockerFieldGeneralName = ()=>{
    const { __ } = useI18n();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Name"),
        required: true,
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "name",
                noStyle: true,
                rules: [
                    {
                        required: true,
                        message: __("Please provide a name!")
                    }
                ],
                children: /*#__PURE__*/ _jsx(Input, {})
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "description",
                ref: setRef,
                children: [
                    /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                        form: "blocker",
                        valueName: "name",
                        widthOfRef: ref,
                        renderDiff: (value)=>/*#__PURE__*/ _jsx(Input, {
                                value: value,
                                readOnly: true
                            })
                    }),
                    __('Each content blocker should have a descriptive name that is understandable to a non-professional user, e.g. "Google Maps".')
                ]
            })
        ]
    });
};
export { FormContentBlockerFieldGeneralName };
